import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import ProductApprovalListContainer from '../../containers/product/ProductApprovalListContainer';
import { PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';

const ProductApprovalList = () => {
  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_APPROVAL_LIST}>
      <ProductApprovalListContainer pageName={PRODUCT_PAGE_NAME.PRODUCT_APPROVAL_LIST} />
    </PageTemplate>
  );
};

export default ProductApprovalList;
